export default "__VITE_ASSET__DIYDYQa1__"